// frontend/src/pages/admin/EmailsAdmin.jsx
// Last Updated: March 24, 2025
// Purpose: Admin page to list all leads with their states and provide links to manage emails for each lead.

import React, { useState, useEffect } from 'react';
import { getAdminLeads } from '../../api';
import { Alert, AlertDescription, AlertTitle } from '../../components/ui/alert';
import { Spinner } from '../../components/ui/spinner';
import EmailManagementList from '../../components/admin/EmailManagementList';

const EmailsAdmin = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        setLoading(true);
        const response = await getAdminLeads();
        if (response.success) {
          setLeads(response.leads || response.data || []);
        } else {
          setError(response.message || 'Failed to load leads');
        }
      } catch (err) {
        console.error('Error fetching leads:', err);
        setError('Failed to load leads');
      } finally {
        setLoading(false);
      }
    };

    fetchLeads();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spinner className="h-8 w-8" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="destructive">
        <AlertTitle>Error</AlertTitle>
        <AlertDescription>{error}</AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="p-4 sm:p-6">
      <h1 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">Email Management</h1>
      <EmailManagementList leads={leads} />
    </div>
  );
};

export default EmailsAdmin;